/**
 * K6 OOD 고정 문구 (ADR 0001 §1.5) — 단일 출처.
 *
 * RoMSHBadge 와 ConclusionStripV2 양쪽에서 import해 사용합니다.
 * 문구 변경 시 이 파일 한 곳만 수정하면 됩니다.
 *
 * iter2 C-2 (수사관 페르소나 평가 4/10 회복): ML 직역 → 행동 가이드형 재작성.
 *   이전: "본 모델은 학습 데이터 분포 밖 시료에서 보수적으로 출력될 수 있습니다.
 *         절대 확률값 해석은 보류하고 수사관 검토를 필수로 진행하세요."
 *   현재: 수사관 의사결정 가이드 중심으로 단어 교체. 신뢰도 표현은 forensic 정직성 유지.
 */
export const ROMSH_OOD_WARNING =
  "이 시료는 모델 학습 패턴과 달라 결과 신뢰도가 낮습니다. 확률값을 단독 근거로 사용하지 말고 전문가 검토를 권고합니다.";
